import { Reveal, SectionHeading } from "../Reveal";

const STEPS = [
    { n: "01", title: "Discover", text: "Tell us what you need." },
    { n: "02", title: "Understand", text: "Organize your medical information and healthcare needs." },
    { n: "03", title: "Explore", text: "Discover appropriate hospitals and specialists." },
    { n: "04", title: "Consult", text: "Connect with qualified healthcare professionals." },
    { n: "05", title: "Decide", text: "Compare treatment pathways and estimated costs." },
    { n: "06", title: "Travel", text: "Coordinate visa, travel and accommodation." },
    { n: "07", title: "Treat", text: "Coordinate your hospital journey." },
    { n: "08", title: "Recover", text: "Continue your care journey after returning home." },
];

export default function Journey() {
    return (
        <section id="how-it-works" data-testid="journey-section" className="py-28 lg:py-36 bg-tint-slate noise-overlay overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
                    <SectionHeading
                        chapter="02"
                        eyebrow="The Solution"
                        title="One journey. One intelligent platform."
                        description="From the first question to recovery back home — every step of the cross-border healthcare journey, connected."
                        testid="journey-heading"
                    />
                </div>
                <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="journey-track">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={0.06 * i} className="h-full">
                            <div
                                data-testid={`journey-step-${s.n}`}
                                className="group relative h-full bg-white rounded-3xl border border-slate-100 p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1.5 hover:shadow-[0_24px_48px_rgb(10,37,64,0.10)] hover:border-brand-green/30 transition-[transform,box-shadow,border-color] duration-300"
                            >
                                <div className="flex items-center gap-4">
                                    <span className="font-heading text-4xl font-bold text-outline group-hover:text-brand-green group-hover:[-webkit-text-stroke:0] transition-all duration-300">{s.n}</span>
                                    <span className="h-px flex-1 bg-slate-100 group-hover:bg-brand-green/30 transition-colors duration-300" />
                                </div>
                                <h3 className="mt-8 font-heading text-2xl font-semibold text-brand-blue">{s.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
